import React from 'react';
import { FaStore, FaShoppingCart, FaHandshake } from 'react-icons/fa';

const Services = () => {
  return (
    <section id="services" className="section bg-light-dark">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-primary mb-4">SEO Services</h2>
          <p className="text-dark max-w-3xl mx-auto text-lg">
            We offer tailored SEO solutions to meet your specific business needs. Whether you're a small local business 
            or a growing e-commerce store, we have the expertise to boost your online visibility.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <ServiceCard 
            icon={<FaStore className="text-accent text-4xl" />}
            title="Small Business SEO"
            price="From £300 per month"
            features={[
              "Keyword research and optimization",
              "On-page SEO improvements",
              "Local SEO optimization",
              "Monthly reporting and analytics",
              "Content recommendations",
              "Technical SEO audit"
            ]}
          />
          
          <ServiceCard 
            icon={<FaShoppingCart className="text-accent text-4xl" />}
            title="E-commerce SEO"
            price="From £600 per month"
            features={[
              "Product page optimization",
              "Category page optimization",
              "Shopping feed optimization",
              "Competitor analysis",
              "Conversion rate optimization",
              "Structured data implementation"
            ]}
          />
          
          <ServiceCard 
            icon={<FaHandshake className="text-accent text-4xl" />}
            title="White Label SEO"
            price="Custom pricing"
            features={[
              "Resellable SEO services",
              "Branded reporting",
              "Seamless client management",
              "API integration options",
              "Competitive wholesale pricing",
              "Complete confidentiality"
            ]}
          />
        </div>
      </div>
    </section>
  );
};

const ServiceCard = ({ icon, title, price, features }) => {
  return (
    <div className="card group hover:shadow-xl transition-shadow duration-300 flex flex-col h-full bg-primary text-white">
      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-light mb-4">
          {icon}
        </div>
        <h3 className="text-white mb-2">{title}</h3>
        <div className="text-accent font-bold text-xl mb-4">{price}</div>
      </div>
      
      <ul className="space-y-3 mb-8 flex-grow">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start">
            <svg className="w-5 h-5 text-accent mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      
      <div className="mt-auto">
        <a href="/contact" className="btn bg-accent text-primary w-full text-center font-bold hover:bg-accent-light transition-colors">
          Find Out More
        </a>
      </div>
    </div>
  );
};

export default Services;